import { isDefined } from "@clipboard-health/util-ts";
import { FormControl, FormHelperText, FormLabel, MenuItem, Select } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { type Control, Controller } from "react-hook-form";

import { type ExtendShiftFormValues, SHIFT_EXTENSION_REASONS } from "./extendShiftFormSchema";

interface ExtendShiftReasonsFieldProps {
  control: Control<ExtendShiftFormValues>;
}

export function ExtendShiftReasonsField(props: ExtendShiftReasonsFieldProps) {
  const { control } = props;

  return (
    <FormControl fullWidth>
      <FormLabel id="reasons-label">
        <Text semibold variant="body2">
          Why are you intending to stay past clock-out time?
        </Text>
      </FormLabel>
      <Controller
        name="reasons"
        control={control}
        render={({ field, fieldState }) => (
          <>
            <Select
              displayEmpty
              labelId="reasons-label"
              value={field.value[0] ?? ""}
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <Text variant="body2" sx={{ color: (theme) => theme.palette.text.disabled }}>
                      Select a reason
                    </Text>
                  );
                }
                return selected;
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxWidth: "100%",
                  },
                },
              }}
              onChange={(event) => {
                const { value } = event.target;

                field.onChange(value ? [value] : []);
              }}
            >
              {SHIFT_EXTENSION_REASONS.map((reason) => (
                <MenuItem
                  key={reason}
                  value={reason}
                  sx={{
                    borderRadius: 0,
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  <Text variant="body2">{reason}</Text>
                </MenuItem>
              ))}
            </Select>
            {isDefined(fieldState.error) && (
              <FormHelperText error>{fieldState.error.message}</FormHelperText>
            )}
          </>
        )}
      />
    </FormControl>
  );
}
